import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { TranslocoModule } from '@ngneat/transloco';
import { SnackWarningContainer } from './snack-warning.container';

@NgModule({
  declarations: [ SnackWarningContainer ],
  imports: [
    CommonModule,
    MatButtonModule,
    TranslocoModule
  ],
  exports: [ SnackWarningContainer ]
})
export class SnackWarningModule {

}
